import * as Sentry from '@sentry/browser'

if (import.meta.env?.VITE_SENTRY_DSN) {
  Sentry.init({
    enabled: import.meta.env?.NODE_ENV === 'production',
    dsn: import.meta.env?.VITE_SENTRY_DSN,
    release: import.meta.env?.VITE_COMMIT_HASH,
  })
}
